export default {
  props: {
    benefit: Object | Array,
    options: {
      type: Object,
      default: () => {
        return {
          check: false,
          enabled: false,
        };
      },
    },
  },
};
